export default {
  cgv: null,
  announcement: null,
  faq: [],
  faqCategories: []
}
